import styles from './RangeSelector.module.css';

export interface RangePreset {
  id: string;
  label: string;
  days: number;
}

export const RANGE_PRESETS: readonly RangePreset[] = [
  { id: '7d', label: '7 days', days: 7 },
  { id: '30d', label: '30 days', days: 30 },
  { id: '90d', label: '90 days', days: 90 },
  { id: '365d', label: '365 days', days: 365 },
];

interface RangeSelectorProps {
  value: RangePreset;
  onChange: (next: RangePreset) => void;
}

export function RangeSelector({ value, onChange }: RangeSelectorProps) {
  return (
    <div className={styles.row} role="tablist">
      {RANGE_PRESETS.map((p) => (
        <button
          key={p.id}
          type="button"
          role="tab"
          aria-selected={p.id === value.id}
          className={p.id === value.id ? styles.activeChip : styles.chip}
          onClick={() => onChange(p)}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
